import { render, staticRenderFns } from "./Fatture.vue?vue&type=template&id=33e3b31e&scoped=true&"
import script from "./Fatture.vue?vue&type=script&lang=js&"
export * from "./Fatture.vue?vue&type=script&lang=js&"
import style0 from "./Fatture.vue?vue&type=style&index=0&id=33e3b31e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e3b31e",
  null
  
)

export default component.exports